type Props = {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  strokeWidth: number;
};

export const Bar = ({
  className = 'stroke-p-white-100',
  ...rest
}: Props & { className?: string }) => {
  return <line {...rest} className={className} />;
};
